import axios from 'axios';
import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import apiClient from '../utils/api-client';
import SimpleLoader from './Common/Loading';
import PageHeader from './Common/PageHeader';
import './Sitemap.css';
const Sitemap = () => {
  const [sitemap, setSitemap] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState(null);
  const [products, setProducts] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  useEffect(() => {
    // Fetch sitemap data
    apiClient
      .get('/sitemap')
      .then((response) => {
        setSitemap(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        setErrors(error.message);
        setLoading(false);
      });
    // Fetch products data
    apiClient
      .get('/products')
      .then((response) => {
        setProducts(response.data.data);
      })
      .catch((error) => {
        console.error('Error fetching products:', error);
      });
    // Fetch subcategories data
    axios
      .get('https://api.bakumia.pk/backend-api/get-product-sub-cate')
      .then((response) => {
        setSubcategories(response.data.data);
      })
      .catch((error) => {
        console.error('Error fetching subcategories:', error);
      });
  }, []);
  if (loading) {
    return <SimpleLoader />;
  }
  if (errors) {
    return <div>Error: {errors}</div>;
  }
  const isProductLink = (url) => {
    const parts = url.split('/');
    if (parts.length === 3 && subcategories && products) {
      const [subcategorySlug, productSlug] = parts.slice(0, 2); // Take the first two parts
      return (
        products.some((product) => product.product_slug === productSlug) &&
        subcategories.some(
          (subcategory) => subcategory.s_cat_slug === subcategorySlug
        )
      );
    }
    return false;
  };
  return (
    <>
      <PageHeader title="Bakumia Sitemap" url="Sitemap" />
      <div className="container-fluid py-5">
        <div className="sitemap-wrapper">
          {sitemap.map((item) => (
            <NavLink
              key={item.s_id}
              to={
                isProductLink(item.s_url)
                  ? `/shop/${item.s_url}`
                  : `/${item.s_url}`
              }
              className="sitemap-link"
            >
              <i className="fa fa-link me-2"></i>
              <span style={{ maxWidth: '260px' }} className="text-truncate">
                {item.s_title}
              </span>
            </NavLink>
          ))}
        </div>
      </div>
    </>
  );
};
export default Sitemap;
